import { styled } from '@mui/material/styles';
import { IMaskInput } from 'react-imask';

export const InputContainer = styled(IMaskInput)``;
